// extracted by mini-css-extract-plugin
export default {"emptyContainer":"empty-constructor_emptyContainer__Tr4eN","text":"empty-constructor_text__iVzW2"};